import React, { useEffect } from 'react'

import { useThemeStore } from 'Stores/ThemeStore'

export default function ThemeStoreWiring() {
  const setIsLoading = useThemeStore((x) => x.setIsLoading)
  useEffect(() => {
    window.addEventListener('pageshow', () => setIsLoading(false))
  }, [setIsLoading])

  return <></>
}
